import axios from '../axios'
import qs from 'qs';

/* 
 * 角色管理模块
 */

// 查询
export const list = (data) => {
	data = qs.stringify(data);
	return axios({
		url: '/kz/role/list',
		method: 'post',
		data
	})
}



// WEBPACK FOOTER //
// ./src/http/moudules/role.js